import {SPRED_PAGES} from "@main/constants";
import {removeCurrent} from "@main/helpers";

export class PageNav {
    constructor(el) {
        this.el = el;
        this.list = this.el.closest(".js-list");
        this.separator = "....";
        this.current = 1;
        if (this.el.dataset.pages) {
            this.build(this.el.dataset.pages);
        }
    }

    getCurrentPage() {
        return this.current;
    }

    build(pages, current = false) {
        this.pages = Number(pages);
        if (current) {
            this.current = Number(current);
        }
        if (this.current > this.pages) {
            this.current = 1;
        }
        this.el.innerHTML = "";
        if (!this.isEmpty()) {
            this.calcCentralRange();

            if (this.shiftStart > 1) {
                this.printSeparator();
            }
            for (let i = this.shiftStart; i <= this.shiftEnd; i++) {
                this.printItem(i);
            }
            if(this.shiftEnd < this.pages ) {
                this.printSeparator();
            }
            this.initEvents();
        }
    }

    calcCentralRange() {
        /**
         * Сколько показывать кнопок страниц до и после актуальной
         * Пример:
         * SPRED_PAGES = 2
         * Всего 9 страниц навигации и сейчас просматривают 5ю
         * 1 ... 3 4 5 6 7 ... 9
         * shiftStart = начало средней части (3 в этом примере)
         * shiftEnd = конец средней части (7 в этом примере)
         *
         */
        this.shiftStart = Math.max( this.current - SPRED_PAGES, 1 );
        this.shiftEnd = Math.min( this.current + SPRED_PAGES, this.pages );
        if( this.shiftEnd < SPRED_PAGES * 2 + 1 ) {
            this.shiftEnd = Math.min( SPRED_PAGES * 2 + 1, this.pages );
        }
        if( this.shiftEnd === this.pages && this.shiftStart > 1 ) {
            this.shiftStart = Math.max( 1,  Math.min( this.pages - SPRED_PAGES * 2, this.shiftStart ) );
        }
    }

    isEmpty() {
        if (!this.pages || this.pages <= 1) {
            return true;
        }
        return false;
    }

    printItem(pageNum) {
        let itemClass = "";
        if (pageNum === this.current) {
            itemClass = "current";
        } else {
            itemClass = "js-page-nav-item";
        }
        this.el.insertAdjacentHTML(
            "beforeend",
            `<span class="page-nav__item ${itemClass}" data-page="${pageNum}">${pageNum}</span>`
        );
    }

    printSeparator() {
        this.el.insertAdjacentHTML(
            "beforeend",
            `<span class="page-nav__item-separator">${this.separator}</span>`
        );
    }

    initEvents() {
        const items = this.el.querySelectorAll(".js-page-nav-item");
        items.forEach((btn) => {
            btn.addEventListener("click", () => {
                if (!btn.classList.contains("current")) {
                    removeCurrent(items);
                    btn.classList.add("current");
                    this.current = Number(btn.dataset.page);
                    this.list.dispatchEvent(new CustomEvent("loadList"));
                }
            });
        });
    }
}
